import { PlayerPresentationStatus } from '../../../api/presentation.js';

/**
 * @param {PresentationData} presentationData
 * @returns {Promise<PresentationData>}
 */
export function ensurePresentationAvailable(presentationData) {
    const availableStatuses = [
        PlayerPresentationStatus.Viewable,
        PlayerPresentationStatus.Scheduled
    ];
    const { playerPresentationStatus: status } = presentationData.metadata;
    if (availableStatuses.includes(status)) {
        return Promise.resolve(presentationData);
    }
    else {
        return Promise.reject(presentationData.metadata.playerPresentationStatusMessage);
    }
}
